module.exports = __webpack_public_path__ + "static/media/municipal tax & services.6a74d102.png";